import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'moon-2', 'Moon2', [["path",{"d":"M16.418 4.157a8 8 0 0 0 0 15.686"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}]]);